// src/auth/index.js - Barrel export file to prevent duplicate imports

// Import components from the same directory
import LoginComponent from './Login';
import SignupComponent from './Signup';
import ForgotPasswordComponent from './ForgotPassword';
import ProtectedRouteComponent from './ProtectedRoute';

// Export with renamed variables to avoid conflicts
export const Login = LoginComponent;
export const Signup = SignupComponent;
export const ForgotPassword = ForgotPasswordComponent;
export const ProtectedRoute = ProtectedRouteComponent;

// Default exports for backward compatibility
export default {
  Login: LoginComponent,
  Signup: SignupComponent,
  ForgotPassword: ForgotPasswordComponent,
  ProtectedRoute: ProtectedRouteComponent
};